import { LineItemV2SortOptions, SortDirectionOptions } from '../../../graphql/types';
import { PaginationState } from '../../utils/pagination';
import { NUM_ITEMS } from './constants';
import { sortStateV2 } from './types';

export const defaultSortState: sortStateV2 = {
  sortBy: LineItemV2SortOptions.sellDate,
  sortDir: SortDirectionOptions.asc,
};

export const defaultPaginationOptions: PaginationState = {
  pageSize: NUM_ITEMS,
  page: 1,
};
